<template>
  <v-wait :for="loaderId">
    <template slot="waiting">
      <half-circle-spinner />
      <div class="spinner-message my-3 text-center">
        Loading the data...
      </div>
    </template>
    <recruiter-form
      v-if="profile"
      ref="recruiterForm"
      :initial-data="profile"
    >
      <template slot="email-input">
        <slot name="email-input" />
      </template>
    </recruiter-form>
  </v-wait>
</template>

<script>
import Api from '@/providers/Api';
import RecruiterForm from '@/components/recruiter/form/RecruiterForm';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  name: 'RecruiterAdminProfile',
  components: {
    RecruiterForm,
    HalfCircleSpinner,
  },
  props: {
    userId: [Number, String],
  },
  data: function () {
    return {
      profile: null,
    };
  },
  created: function () {
    this.getProfileData();
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
  },
  methods: {
    hasErrors: function () {
      return this.$refs.recruiterForm.hasErrors();
    },
    validate: function () {
      return this.$refs.recruiterForm.validate();
    },
    getData: function () {
      return this.$refs.recruiterForm.getData();
    },
    getProfileData: async function () {
      this.$wait.start(this.loaderId);
      try {
        this.profile = await Api.getRecruiterProfileForAdmin(this.userId);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
  },
};
</script>

<style scoped></style>
